// @flow

import React, { Component } from 'react';
import moment from 'moment';
import styler from 'react-styling';
import { Circle } from 'rc-progress';

const HOUR_FORMAT = 'HH:mm';
const DAY_FORMAT = 'dddd';

const organizerStyle = styler `
  Container
    color: #F5F5F5
    font-size: 2vw
    margin-top: 0.5vw
  Image
    height: 2.5vw
    width: 2.5vw
    border-radius: 50%
    margin-right: 0.5vw
`;

const progressStyle = styler `
  ProgressContainer
    width: 100%
  InfoWrap
    width: 43vw
    height: 43vw
    max-width: 65vh
    max-height: 65vh
    position: absolute
  Info
    top: 50%
    left: 50%
    position: absolute
    transform: translate(-50%, -50%)
  InnerCircleText
    color: #D9144A
    font-size: 3.5vw
`;

const MeetingroomOrganizer = (props: { organizer: Object }) => {
  const { displayName, email } = props.organizer;
  return (
    <div style={organizerStyle.Container}>
      <img
        style={organizerStyle.Image}
        src={email ? `/contacts/photo/${email}` : null}
        alt={displayName}
      />
    </div>
  );
};


const MeetingDateRange = (props: { start: Object, end: Object, style: Object }) => {
  const { start, end, style } = props;
  const startTime = start.format(HOUR_FORMAT);
  const endTime = end.format(HOUR_FORMAT);

  const meetingDuration = moment.duration(end.diff(start)).asDays();
  let startElement = (startTime);
  let endElement = (endTime);
  if (meetingDuration > 1) {
    startElement = (`${startTime} (${start.format(DAY_FORMAT)})`);
    endElement = (`${endTime} (${end.format(DAY_FORMAT)})`);
  }
  return (
    <span style={style}>
      {startElement} - {endElement}
    </span>
  );
};

class MeetingroomBusyStatus extends Component {

  props: {
    event: Object,
    clock: Object,
  };

  render() {
    const { start, end, organizer } = this.props.event;
    const meetingDuration = moment.duration(end.diff(start)).asSeconds();
    const now = this.props.clock;
    const elapsedDuration = moment.duration(now.diff(start)).asSeconds();
    const elapsedPercentage = (elapsedDuration / meetingDuration) * 100;
    return (
      <div>
        <div style={progressStyle.InfoWrap}>
          <div style={progressStyle.Info}>
            <MeetingDateRange start={start} end={end} style={progressStyle.InnerCircleText} />
            <MeetingroomOrganizer organizer={organizer} />
          </div>
        </div>
        <div style={progressStyle.ProgressContainer}>
          <Circle
            percent={elapsedPercentage}
            strokeWidth="10"
            trailWidth="9.8"
            strokeColor="#182B56"
            trailColor="#D9144A"
            strokeLinecap="butt"
          />
        </div>
      </div>
    );
  }

}

export default MeetingroomBusyStatus;



// WEBPACK FOOTER //
// ./src/js/Components/MeetingRooms/MeetingroomBusyStatus.js